<template lang="">
    <transition mode="out-in">
        <router-view />
    </transition>
</template>
<script>
export default {
    created () {
        this.$router.push('dashboard')
    }
}
</script>
<style>
.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 0.2s }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 0.2s }
.v-enter-to { opacity: 1; }

</style>


// WEBPACK FOOTER //
// src/components/Content.vue